import React, { createContext, useContext, useState, useEffect } from 'react';

const SidebarContext = createContext();

export const useSidebar = () => {
  const context = useContext(SidebarContext);
  if (!context) {
    throw new Error('useSidebar must be used within a SidebarProvider');
  }
  return context;
};

export const SidebarProvider = ({ children }) => {
  const [expanded, setExpanded] = useState(true);
  const [hoveredLabel, setHoveredLabel] = useState(null);

  // Load state from localStorage on mount
  useEffect(() => {
    const savedState = localStorage.getItem('sidebarExpanded');
    if (savedState !== null) {
      setExpanded(savedState === 'true');
    }
  }, []);

  const toggleExpanded = () => {
    setExpanded(prev => {
      const newState = !prev;
      localStorage.setItem('sidebarExpanded', newState);
      return newState;
    });
  };

  return (
    <SidebarContext.Provider value={{ expanded, setExpanded, toggleExpanded, hoveredLabel, setHoveredLabel }}>
      {children}
    </SidebarContext.Provider>
  );
};
